module.exports = __webpack_public_path__ + "53ea4f1fcd9e50e55bd75f9178d8abe2.svg";